const mainProjects = [
  {
    name: 'Star Wars Planets Search',
    describe: `Aplicação front-end que exibe dados dos planetas do universo de Star Wars,
    que são lidos de uma Api REST e podem ser filtrados.`,
    stacks: 'React | Redux | CSS',
    github: 'https://github.com/renatapnunes/starwars-planets-search',
    vercel: 'https://starwars-planets-search.vercel.app/',
  },
  {
    name: 'Trivia',
    describe: `Aplicação front-end que consome dados de uma Api REST para construção
    de um jogo Trivia. Também faz uso da Api do Gravatar, para uso de avatares.`,
    stacks: 'React | Context Api | Hooks | CSS',
    github: 'https://github.com/renatapnunes/trivia',
    vercel: 'https://trivia-livid-iota.vercel.app/',
  },
  {
    name: 'Task Organizer',
    describe: `Aplicação full stack para organização de tarefas. Realiza CRUD em um
    banco de dados e permite filtrar as tarefas por status e data.`,
    stacks: 'React | Node | Express | MongoDB | Mocha | CSS',
    github: 'https://github.com/renatapnunes/task-organize-frontend',
    vercel: '',
  },
];

export default mainProjects;
